import { apiClient } from '../api/client';
import axios from 'axios';

async function messageFromBlob(data: Blob, fallback: string): Promise<string> {
  try {
    const text = await data.text();
    const parsed = JSON.parse(text) as { message?: string };
    return parsed.message || fallback;
  } catch {
    return fallback;
  }
}

export async function downloadPdfBlob(url: string, fallbackFileName: string): Promise<void> {
  try {
    const { data } = await apiClient.get<Blob>(url, { responseType: 'blob' });
    if (data.type && data.type.includes('application/json')) {
      throw new Error(await messageFromBlob(data, 'PDF 다운로드에 실패했습니다.'));
    }
    const objectUrl = window.URL.createObjectURL(data);
    const anchor = document.createElement('a');
    anchor.href = objectUrl;
    anchor.download = fallbackFileName;
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    window.URL.revokeObjectURL(objectUrl);
  } catch (err) {
    if (axios.isAxiosError(err) && err.response?.data instanceof Blob) {
      throw new Error(await messageFromBlob(err.response.data, 'PDF 다운로드에 실패했습니다.'));
    }
    if (err instanceof Error) throw err;
    throw new Error('PDF 다운로드에 실패했습니다.');
  }
}
